import React, { useEffect, useState } from "react";
import useIsLoading from "../../../services/hooks/useIsLoading";
import useIsEditMode from "../../../services/hooks/useEditMode";
import TextField from "../TextField/TextField";
import Button from "../Button/Button";
import { Check } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { changeSidebarItemName } from "../../../services/api/sidebar.api";
import {
  MessageType,
  MessageTypeEnum,
  setMessage,
} from "../../../redux/reducers/messageReducer";
import DiagnosisText, {
  DisagnosisTextType,
} from "../../molecules/DiagnosisText/DiagnosisText";
import TabletEditModeTutorial from "../../molecules/TabletEditModeTutorial/TabletEditModeTutorial";
import { useTranslation } from "react-i18next";

interface FormTitleProps {
  sidebarItemID: number;
  title: string;
  warningText?: string;
  adviseText?: string;
  onTitleChange: (title: string) => void;
  onDiagnosisTextChange: (type: DisagnosisTextType, value: string) => void;
}

const FormTitle = (props: FormTitleProps) => {
  const {
    title,
    sidebarItemID,
    warningText,
    adviseText,
    onTitleChange,
    onDiagnosisTextChange,
  } = props;

  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    setTextValue(title);
  }, [title]);

  const { isReportLoading } = useIsLoading();
  const isInEditMode = useIsEditMode();
  const isTabletView = window.innerWidth < 1440;

  const [textValue, setTextValue] = useState(title);

  if (isReportLoading) {
    return <h1 className="dui-form-fields-title">{t("loading")}...</h1>;
  }

  const handleSaveTitle = () => {
    if (textValue !== title) {
      changeSidebarItemName(dispatch, sidebarItemID, textValue).then(
        (response) => {
          if (response !== undefined && response.length > 0) {
            const message: MessageType = {
              type: MessageTypeEnum.Success,
              display: "toaster",
              description: t("editTitleDone"),
            };
            dispatch(setMessage(message));
            onTitleChange(textValue);
          }
        }
      );
    }
  };

  if (isInEditMode) {
    return (
      <div className="dui-form-fields-title-edit">
        <TextField
          value={textValue}
          onChange={setTextValue}
          onEnter={handleSaveTitle}
        />
        <Button
          type="text"
          corners="rounded"
          icon={<Check />}
          className="dui-btn-save"
          onClick={handleSaveTitle}
        />
        {isTabletView && (
          <>
            <DiagnosisText
              warningText={warningText}
              adviseText={adviseText}
              onTextChange={onDiagnosisTextChange}
            />
            <TabletEditModeTutorial />
          </>
        )}
      </div>
    );
  }
  return <h1 className="dui-form-fields-title">{title}</h1>;
};

export default FormTitle;
